import React, { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { About } from './About';
import { Blog } from './Blog';
import { MobileAbout } from './MobileAbout';
import { MobileBlog } from './MobileBlog';
import { MobileServicesPrices } from './MobileServicesPrices';
import { ServicesPrices } from './ServicesPrices';
import { Video } from './Video';

export const Content = () => {
  const { mobileMode } = useContext(AppContext);

  return (
    <div className="page-content" id="content">
      <div className="container">
        {mobileMode ? <MobileAbout /> : <About />}
        {mobileMode ? <MobileServicesPrices /> : <ServicesPrices />}
      </div>
      <div className="video-container">
        <Video />
      </div>
      <div className="container">
        {mobileMode ? <MobileBlog /> : <Blog />}
        {/* Some text */}
      </div>
    </div>
  );
};
